import * as types from '../../actionTypes'

const initialState = {
  isFetchingPreviewDeleteUser: false,
  isDeletingUser: false,
  previewDeleteUserResults: null,
  previewDeleteUserError: null,
  deleteUserResults: null,
  deleteUserError: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCHING_PREVIEW_DELETE_USER:
      return {
        ...state,
        isFetchingPreviewDeleteUser: true,
      }
    case types.FETCHING_PREVIEW_DELETE_USER_SUCCESS:
      return {
        ...state,
        isFetchingPreviewDeleteUser: false,
        deleteUserResults: null,
        deleteUserError: null,
        previewDeleteUserResults: action.previewDeleteUserResults,
        previewDeleteUserError: null,
      }
    case types.FETCHING_PREVIEW_DELETE_USER_ERROR:
      return {
        ...state,
        isFetchingPreviewDeleteUser: false,
        deleteUserResults: null,
        deleteUserError: null,
        previewDeleteUserResults: null,
        previewDeleteUserError: action.previewDeleteUserError,
      }
    case types.DELETING_USER:
      return {
        ...state,
        isDeletingUser: true,
      }
    case types.DELETING_USER_SUCCESS:
      return {
        ...state,
        deleteUserResults: action.deleteUserResults,
        deleteUserError: null,
        previewDeleteUserResults: null,
        previewDeleteUserError: null,
        isDeletingUser: false,
      }
    case types.DELETING_USER_ERROR:
      return {
        ...state,
        deleteUserResults: null,
        deleteUserError: action.deleteUserError,
        previewDeleteUserResults: null,
        previewDeleteUserError: null,
        isDeletingUser: false,
      }
    default:
      return state
  }
}
